export default __webpack_public_path__ + "static/media/ketoicecream-wide@3x.a671f7f4.jpg";